enum FieldRenderSubType {
  REGISTRATION = "REGISTRATION",
  COMPETITOR = "COMPETITOR",
  COMMUNITY_SPONSOR = "COMMUNITY_SPONSOR",
  DIVISION = "DIVISION",
  ORGANIZATION_LEVEL = "ORGANIZATION_LEVEL"
}

export default FieldRenderSubType;
